import { Box } from "@mui/material";
import React from "react";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import PropTypes from 'prop-types';
import "./AutoCompleteSearch.css";
import { Form } from "react-bootstrap";
import Input from "../../Components/Input/Input";

const AutoCompleteSearch = ({
  data,
  departmentData,
  setDepartmentData,
  title,
  disabled = false,
  setSearchContent,
  searchContent,
  isTrue = false
}) => {
  // Format the data array to match the expected structure
  const formattedItems = React.useMemo(() => {
    if (!data || !Array.isArray(data)) return [];
    return data.map(item => ({
      id: item._id,
      name: item.full_name,
      _original: item // preserve original item data
    }));
  }, [data]);

  const handleOnSelect = (item) => {
    setDepartmentData(item?._original?._id || "");
    if (isTrue && setSearchContent) {
      setSearchContent({ 
        ...searchContent, 
        employee_code: "", 
        full_name: "", 
        department: "", 
        designation: "", 
        shift: "",
        id: item._original._id 
      });
    }
  };

  const handleOnSearch = (string, results) => {
    if (results.length > 0 && results[0]._original) {
      setDepartmentData(results[0]._original._id);
    } else {
      setDepartmentData("");
    }
  };

  const formatResult = (item) => {
    return item.name || "";
  };

  return (
    <Box className="autoComplete">
      {disabled ? (
        <Form>
          <Input>
            <Form.Control
              type="text"
              placeholder="Enter Employee Name"
              disabled={true}
            />
          </Input>
        </Form>
      ) : (
        <ReactSearchAutocomplete
          placeholder={title}
          onClear={() => setDepartmentData("")}
          items={formattedItems}
          onSearch={handleOnSearch}
          fuseOptions={{ keys: ["name"] }}
          onSelect={handleOnSelect}
          formatResult={formatResult}
          showIcon={false}
          maxResults={10}
          styling={{
            height: "40px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            backgroundColor: "white",
            boxShadow: "none",
            hoverBackgroundColor: "#eee",
            color: "black",
            fontSize: "16px",
            iconColor: "#6b7280",
            lineColor: "rgb(232, 234, 237)",
            placeholderColor: "#6b7280",
          }}
        />
      )}
    </Box>
  );
};

AutoCompleteSearch.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    full_name: PropTypes.string.isRequired
  })).isRequired,
  departmentData: PropTypes.string,
  setDepartmentData: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  setSearchContent: PropTypes.func,
  searchContent: PropTypes.object,
  isTrue: PropTypes.bool
};

AutoCompleteSearch.defaultProps = {
  disabled: false,
  isTrue: false,
  departmentData: "",
  searchContent: {}
};

AutoCompleteSearch.propTypes = {
  data: PropTypes.array,
  departmentData: PropTypes.string,
  setDepartmentData: PropTypes.func.isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  setSearchContent: PropTypes.func,
  searchContent: PropTypes.object,
  isTrue: PropTypes.bool
};

AutoCompleteSearch.defaultProps = {
  data: [],
  departmentData: "",
  title: "Search...",
  disabled: false,
  isTrue: false
};

export default AutoCompleteSearch;
